<script>
export default {}
</script>

<template>
  <div class="tabs">
    <ul>
      <li>
        <router-link
          :to="{
            name: 'deposit',
          }"
        >
          <span class="tab-text">{{ $t('wallet_page.deposit_list') }}</span>
        </router-link>
      </li>

      <li>
        <router-link
          :to="{
            name: 'withdraw',
          }"
        >
          <span class="tab-text">{{ $t('wallet_page.withdraw_list') }}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>

<style scoped>
.tabs {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  text-align: center;
  word-break: break-all;
}
.tabs li {
  position: relative;
  display: table;
  float: left;
  height: 48px;
  margin-right: 10px;
}
.tabs ul::after {
  display: block;
  clear: both;
  content: '';
}
.tabs li a {
  box-sizing: border-box;
  display: table-cell;
  width: 100%;
  padding: 0 10px;
  font-size: 16px;
  color: #7f8894;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  border: 1px solid #f0f0f0;
  border-radius: 50px;
}
.tabs li a.router-link-active {
  position: relative;
  top: 0;
  left: 0;
  z-index: 1;
  height: 45px;
  background-color: #fff;
  border: 1px solid #2a5cda;
}
.tabs li a.router-link-active span {
  color: #2a5cda;
}

@media screen and (max-width: 768px) {
  .tabs li {
    height: 42px;
  }
  .tabs li a {
    height: 42px !important;
    font-size: 14px;
  }
}
</style>
